import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["store"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ReactReduxContext } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import { injectReducer, injectReducersInBulk } from '../utils/injectAsyncReducer';
export default function withAsyncReducer() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function withAsyncReducerWrapper(ComposedComponent) {
    var WithAsyncReducerHOC = /*#__PURE__*/function (_PureComponent) {
      _inherits(WithAsyncReducerHOC, _PureComponent);
      var _super = _createSuper(WithAsyncReducerHOC);
      function WithAsyncReducerHOC(props, context) {
        var _this;
        _classCallCheck(this, WithAsyncReducerHOC);
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "injectReducer", function (key, reducer) {
          var store = _this.context.store;
          injectReducer(store, key, reducer);
        });
        var storeKey = params.storeKey,
          _reducer = params.reducer,
          bulkReducers = params.bulkReducers;
        var _store = props.store || context.store;
        if (storeKey) injectReducer(_store, storeKey, _reducer);
        if (bulkReducers) injectReducersInBulk(_store, bulkReducers);
        return _this;
      }
      _createClass(WithAsyncReducerHOC, [{
        key: "render",
        value: function render() {
          var _this$props = this.props,
            store = _this$props.store,
            restProps = _objectWithoutProperties(_this$props, _excluded);
          return /*#__PURE__*/React.createElement(ComposedComponent, _extends({}, restProps, {
            injectReducer: this.injectReducer
          }));
        }
      }]);
      return WithAsyncReducerHOC;
    }(PureComponent);
    _defineProperty(WithAsyncReducerHOC, "contextTypes", {
      store: PropTypes.object
    });
    var renderChildrenWithStore = function renderChildrenWithStore(props) {
      return function (store) {
        return /*#__PURE__*/React.createElement(WithAsyncReducerHOC, _extends({
          store: store
        }, props));
      };
    };

    // This is fallback for older react-redux version wherein it still uses older context api
    if (_isEmpty(ReactReduxContext)) {
      return WithAsyncReducerHOC;
    }
    // React-Redux now supports new context api which means it has exposed
    // ReactReduxContext and we can use it's Consumer method to get store instance
    return function (props) {
      return /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, renderChildrenWithStore(props));
    };
  };
}